"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _common = require("@insided/shared/utils/common");

var _NotifyAuthorModal = _interopRequireDefault(require("./NotifyAuthorModal"));

var _ConfigureSystemEmailModal = _interopRequireDefault(require("@insided/control/modules/Emails/ConfigureSystemEmailModal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotifyAuthor = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(NotifyAuthor, _PureComponent);

  var _super = _createSuper(NotifyAuthor);

  function NotifyAuthor() {
    var _this;

    (0, _classCallCheck2.default)(this, NotifyAuthor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showNotifyAuthorModal: false,
      showConfigureSystemEmailModal: false,
      content: _this.props.content
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyAuthorClick", function (show) {
      if (_common.common.isModuleActive('dsaEmailTemplateConfigured')) {
        _this.setState({
          showNotifyAuthorModal: show
        });
      } else {
        _this.setState({
          showConfigureSystemEmailModal: true
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(NotifyAuthor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onShowAlert = _this$props.onShowAlert,
          topicId = _this$props.topicId,
          contentType = _this$props.contentType,
          id = _this$props.id,
          topicPublicId = _this$props.topicPublicId,
          publicReplyId = _this$props.publicReplyId,
          topicTitle = _this$props.topicTitle,
          authorId = _this$props.authorId,
          topicCreatedAt = _this$props.topicCreatedAt,
          repliedAt = _this$props.repliedAt;
      var _this$state = this.state,
          showNotifyAuthorModal = _this$state.showNotifyAuthorModal,
          showConfigureSystemEmailModal = _this$state.showConfigureSystemEmailModal,
          content = _this$state.content;
      return (0, _preact.h)("div", {
        className: "topic-moderation__notify-author-button"
      }, (0, _preact.h)("span", {
        onClick: function onClick() {
          return _this2.onNotifyAuthorClick(true);
        },
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            _this2.onNotifyAuthorClick(true);
          }
        }
      }, "Send moderation notice"), showNotifyAuthorModal && (0, _preact.h)(_NotifyAuthorModal.default, {
        onClose: function onClose() {
          return _this2.setState({
            showNotifyAuthorModal: false
          });
        },
        onShowAlert: onShowAlert,
        privateId: Number(topicId),
        publicId: Number(topicPublicId),
        replyPublicId: Number(publicReplyId),
        replyPrivateId: Number(id),
        contentType: contentType,
        repliedAt: repliedAt,
        topicCreatedAt: topicCreatedAt,
        contentAfterChange: content,
        contentBeforeChange: this.props.content,
        title: topicTitle,
        authorId: Number(authorId)
      }), showConfigureSystemEmailModal && (0, _preact.h)(_ConfigureSystemEmailModal.default, {
        onClose: function onClose() {
          return _this2.setState({
            showConfigureSystemEmailModal: false
          });
        }
      }));
    }
  }]);
  return NotifyAuthor;
}(_preactCompat.PureComponent);

var _default = NotifyAuthor;
exports.default = _default;